var AwayStats = (function () {
    function AwayStats() {
    }
    return AwayStats;
}());
export { AwayStats };
